import actions from './actions'
import toolMng from './metaData/tool'
export default {
  state: toolMng,
  actions
}
